/**
 * @param {string} token
 *
 * @returns {Date}
 */
const getJwtExpiry = (token) => {
    let payload;
    try {
        payload = JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        throw new Error('Error parsing JWT: ' + e.message);
    }

    if (payload?.exp) {
        // Return expiry as Date object.
        // JWT exp is a Unix timestamp in seconds. We need to convert it to milliseconds for Date.
        return new Date(payload.exp * 1000);
    }

    throw new Error('No expiry claim found in token.');
};

module.exports = {
    getJwtExpiry,
};
